export default __webpack_public_path__ + "static/media/livenyte-square-icon.e6688294.jpg";